/* eslint-disable */
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { employScrollState } from '../atoms'
import Board from '../components/board'
export default function Employ(props){
  let [employScroll] = useRecoilState(employScrollState)
  useEffect(() => {
    window.scrollTo({top : employScroll, behavior : 'smooth'})
  }, [])
  return(
    <div className="contents">
      <div className="content-title02">채용공고</div>
      <Board list={props.employList}/>
      {
        props.employList.length == 0 ?
        <div className='no-employ'>등록된 채용공고가 없습니다.</div> : ''
      }
    </div>
  )
}